import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import fnFormatDate, {
  fnFindActiveAnnouncementAlert,
  fnFindUpcomingMaintenanceAlert,
  fnSplitBoldSegments,
} from './helpers';

/**
 * Displays a banner alerting users about upcoming maintenance downtimes
 * that occur within the next 2 days, or an active announcement.
 */
const AlertBanner = ({ aAlerts, bShowAnnouncements }) => {
  const { pathname } = useLocation();

  const oUpcomingMaintenanceAlert =
    fnFindUpcomingMaintenanceAlert(aAlerts);

  // Maintenance downtime always takes priority over announcements
  const oActiveAnnouncementAlert =
    !oUpcomingMaintenanceAlert && bShowAnnouncements
      ? fnFindActiveAnnouncementAlert(aAlerts)
      : null;

  const sFormattedStart = fnFormatDate(oUpcomingMaintenanceAlert?.M?.start?.S);
  const sFormattedEnd = fnFormatDate(oUpcomingMaintenanceAlert?.M?.end?.S);

  if (!oUpcomingMaintenanceAlert && !oActiveAnnouncementAlert) {
    return null;
  }

  return (
    <div
      className={`alertBanner ${
        pathname.includes('sign-in')
          ? 'alertBanner--landingPage'
          : ''
      } ${
        oActiveAnnouncementAlert ? 'alertBanner--announcement' : ''
      }`}
    >
      {oUpcomingMaintenanceAlert ? (
        <p>
          WakeNetwork will be down for maintenance from{' '}
          <strong>{sFormattedStart}</strong> to <strong>{sFormattedEnd}</strong>
          .
        </p>
      ) : (
        <p>
          {fnSplitBoldSegments(oActiveAnnouncementAlert.M.message.S).map(
            (oSegment) =>
              oSegment.bBold ? (
                <strong key={oSegment.sText}>{oSegment.sText}</strong>
              ) : (
                oSegment.sText
              )
          )}
        </p>
      )}
    </div>
  );
};

AlertBanner.propTypes = {
  aAlerts: PropTypes.arrayOf(
    PropTypes.shape({
      M: PropTypes.shape({
        start: PropTypes.shape({ S: PropTypes.string }),
        end: PropTypes.shape({ S: PropTypes.string }),
        message: PropTypes.shape({ S: PropTypes.string }),
        type: PropTypes.shape({ S: PropTypes.string }),
      }),
    })
  ),
  bShowAnnouncements: PropTypes.bool,
};

AlertBanner.defaultProps = {
  aAlerts: [],
  bShowAnnouncements: false,
};

export default AlertBanner;
